module.exports = __webpack_public_path__ + "img/rtl.0012c185.jpg";